import { http } from './httpClient';

export async function getAllSettings(opts = {}) {
  const result = await http.get('/settings', opts);
  return result.data || {};
}

export async function getSetting(key, opts = {}) {
  const result = await http.get(`/settings/${encodeURIComponent(key)}`, opts);
  return result.data;
}

export async function patchSettings(patch, opts = {}) {
  const result = await http.patch('/settings', patch, opts);
  return result.data || {};
}

export async function removeSetting(key, opts = {}) {
  await http.delete(`/settings/${encodeURIComponent(key)}`, opts);
}
